import { useMemo } from 'react';
import { useQueryClient } from '../../lib';
import { getCollectionsKey } from '../../utils/keys';
export const getCachedCollection = (id, queryClient) => {
    const collectionsKey = getCollectionsKey();
    let cachedCollection;
    const data = queryClient.getQueriesData(collectionsKey);
    data === null || data === void 0 ? void 0 : data.forEach(([_, queryData]) => {
        queryData === null || queryData === void 0 ? void 0 : queryData.forEach(collection => {
            if ((collection === null || collection === void 0 ? void 0 : collection.id) === id)
                cachedCollection = collection;
        });
    });
    return cachedCollection;
};
export const useCachedCollection = (id) => {
    const queryClient = useQueryClient();
    return useMemo(() => getCachedCollection(id, queryClient), [id, queryClient]);
};
//# sourceMappingURL=useCachedCollection.js.map